﻿import { RESTError } from "../RESTError";

var BASE_URL = '/api/GroupPermissions';

export enum GroupPermissionType {
    View,
    ViewAndDownload
}

export interface GroupRule {
    GroupId?: string;
    RegionId: string;
    StationId: string;
    SensorId: string;
}

export interface CreateEditGroupPermissionRequest {
    GroupId?: string;
    GroupName: string;
    GroupPermissionType: GroupPermissionType;
    GroupRules: GroupRule[];
}

export interface GroupPermission {
    GroupId: string;
    GroupName: string
    GroupPermissionType: GroupPermissionType;
    GroupRules?: GroupRule[];
}

export interface TreeDataNode extends Fancytree.NodeData {
    children?: TreeDataNode[] | undefined;
    NodeType: string;
    RegionId: string;
    RegionLabel: string;
    StationId?: string;
    StationLabel?: string;
    SensorId?: string;
    SensorLabel?: string;
}

export interface UserGroupAssignmentRequest {
    GroupIds: string[];
    UserId: string;
}

export function getTreeData(callback: (err: RESTError, data: TreeDataNode[]) => any): void {
    $.ajax(BASE_URL + '/TreeData', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 180000, //: NB: a bit longer as this can take a little time..
        success: (data: TreeDataNode[], text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function GetPermissionGroupsForUser(userId: string, callback: (RESTError: any, data: GroupPermission[]) => any): void {
    $.ajax(BASE_URL + '/GroupsForUser?userId=' + encodeURIComponent(userId), {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null,  data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function AssociateUsersWithPermissionGroups( callback: (RESTError: any, data: any[]) => any): void {
    $.ajax(BASE_URL + '/AssociateUsersWithPermissionGroups/' , {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function GetAllPermissionGroups(callback: (RESTError: any, data: GroupPermission[]) => any): void {
    $.ajax(BASE_URL + '/Groups', {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function createPermissionGroup(request: CreateEditGroupPermissionRequest, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/Groups', {
        cache: false,
        type: 'POST',
        data: request,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function editPermissionGroup(request: CreateEditGroupPermissionRequest, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/Groups/' + request.GroupId, {
        cache: false,
        type: 'PUT',
        data: request,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function deletePermissionGroup(groupId: string, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/Groups/' + groupId, {
        cache: false,
        type: 'DELETE',      
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function editUserGroupAssignments(request: UserGroupAssignmentRequest, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/UserAssignments/' + request.UserId, {
        cache: false,
        type: 'PUT',
        data: request,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}